import styled from 'styled-components';

export default styled.div`
  padding: 24px;
  background: ${({ theme }) => theme.bgColorDark};
`;
